import { ethers } from "ethers";
import config from "../config";
import honeycombsabi from "../abis/honeycombs.json";
import Base1155 from "./Base1155";


class Honeycombs extends Base1155 {
    constructor(signer: ethers.Signer | ethers.providers.Provider) {
        super(config.honeycombsAddress, honeycombsabi, signer);
    }

    // Burn honeycomb(s) of a given rarity for an owner
    async burn(owner: string, rarity: number, amount: number) {
        // burn(address _owner, uint256 _rarity, uint256 _amount)
        return await this.contract.burn(owner, rarity, amount);
    }
}

export default Honeycombs;